import * as Yup from "yup"

export const SchemaValidation = (t) => Yup.object().shape({
  name: Yup.string().required(t('required')),
  address: Yup.string().required(t('required')),
  city: Yup.string().required(t('required')),
  state: Yup.string().required(t('required')),
  zip_code: Yup.string().required(t('required')),
  phone: Yup.string().required(t('required')),
  whatsapp: Yup.string().required(t('required')),
  email: Yup.string().required(t('required')),
  logo: Yup.mixed()
    .test("type", "Solo imagenes", (value) => {
      if (value === "" || value === null || value === undefined) {
        console.log("Validation logo", value)
        return true
      } else {
        return Array.isArray(value) && value.length > 0 && value[0].type.includes("image")
      }
    }),
  company: Yup.string().required(t('required')),
  active: Yup.boolean().required(t('required'))
})